import React from "react";
import {useRouter} from "next/router";
import {useSelector} from "react-redux";
import Script from "next/script";
import {IState} from "../../../types/state";
import {schemaPages} from "../../schemaorg";
import PageHeader from "../../shared/PageHeader";
import Content from "./Content";
import {NextPage} from "next";
import {IPageProps} from "../../../types/pages";
import {TranslationsType} from "../../../types/homePageTypes";

interface IProps extends IPageProps {
    pageSlug: string,
}

const SiteCustomPage: NextPage<IProps> = (props) => {
    const {breadcrumb, content} = props;
    const router = useRouter();
    const schema = schemaPages(props.dbName, router.asPath, content)

    return (
        <div className="page">
            <Script
                id={schema.name}
                type="application/ld+json"
                dangerouslySetInnerHTML={{__html: JSON.stringify(schema)}}
            />
            <div>
                <PageHeader breadcrumb={breadcrumb}/>
                <Content {...props}/>
            </div>
        </div>

    );
}

export default SiteCustomPage;
